// Digital Business Card claim code helpers (QR link carries it as ?c=, also accepts ?claim_code=).

const CLAIM_CODE_KEY = "businessCardClaimCode";
const CLAIM_POPUP_KEY = "showBusinessCardClaimPopup";

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore
  }
};

const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export const resolveClaimCode = (searchParams) => {
  const fromUrl = (searchParams?.get("c") || searchParams?.get("claim_code"))?.trim();
  if (fromUrl) {
    safeSet(CLAIM_CODE_KEY, fromUrl);
    return fromUrl;
  }
  return safeGet(CLAIM_CODE_KEY) || null;
};

export const captureClaimCodeFromUrl = () => resolveClaimCode(new URLSearchParams(window.location.search));

export const markClaimCodeUsed = () => {
  safeRemove(CLAIM_CODE_KEY);
  safeSet(CLAIM_POPUP_KEY, "true");
};

export const shouldShowClaimPopup = () => safeGet(CLAIM_POPUP_KEY) === "true";

export const dismissClaimPopup = () => safeRemove(CLAIM_POPUP_KEY);
